import { Check } from "lucide-react";

export default function ThankYou({ count }) {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-8 text-center"
      style={{ background: "linear-gradient(160deg, #0B3D2E 0%, #16784A 100%)" }}
      data-testid="thankyou-screen"
    >
      <div
        className="w-24 h-24 rounded-full bg-white flex items-center justify-center gb-pop"
        style={{ boxShadow: "0 12px 40px rgba(0,0,0,0.25)" }}
      >
        <Check className="w-12 h-12" strokeWidth={3} style={{ color: "#16a34a" }} />
      </div>
      <h1 className="mt-8 text-3xl font-wordmark font-extrabold text-white gb-fade-up" style={{ animationDelay: "150ms" }}>
        All done — thank you!
      </h1>
      <p className="mt-3 text-[15px] text-white/85 max-w-xs leading-relaxed gb-fade-up" style={{ animationDelay: "300ms" }}>
        Your {count ? `${count} ` : ""}answer{count === 1 ? "" : "s"} went straight to Greenbooks.
        You can close this page.
      </p>
      <div className="mt-10 flex flex-col items-center gb-fade-up" style={{ animationDelay: "450ms" }}>
        <span className="font-wordmark font-extrabold tracking-tight text-white text-lg">
          GREENBOOKS
        </span>
        <span className="font-wordmark font-medium text-[9px] tracking-[0.32em] text-[#A8E0BE] mt-1">
          CONSULTING&nbsp;INC.
        </span>
      </div>
    </div>
  );
}
